import api from './api';

export const getBackups = async () => {
  const response = await api.get('/backups');
  return response.data.data;
};

export const getBackup = async (id) => {
  const response = await api.get(`/backups/${id}`);
  return response.data.data;
};

export const createBackup = async (backupData) => {
  const response = await api.post('/backups', backupData);
  return response.data.data;
};

export const scheduleBackup = async (backupData) => {
  const response = await api.post('/backups/schedule', backupData);
  return response.data.data;
};

export const deleteBackup = async (id) => {
  await api.delete(`/backups/${id}`);
};